// Internal modules
import { appStore } from '@/store';
import { $logger, apolloClient, getLocale, getToken } from '@/lib';
import { CURRENCY_CONVERSION_FROM_CREDIT_CARD_QUERY } from './graphql';

const getCurrencyConversionData = () => {
  const { form: formState } = appStore.getState();
  const { cardType, value: cardNumber } = formState.cardNumber;
  const variables = {
    cardBrand: cardType,
    cardNumber,
    country: getLocale().country,
    token: getToken(),
  };

  return apolloClient
    .query({
      fetchPolicy: 'no-cache',
      query: CURRENCY_CONVERSION_FROM_CREDIT_CARD_QUERY,
      variables,
    })
    .then(response => {
      if (response?.errors?.length) {
        throw new Error(response.errors[0]);
      }

      const {
        currencyConversionFromCreditCard: conversionData,
      } = response.data;
      const { cardType } = appStore.getState().form.cardNumber;

      /**
       * For certain cards the response will be null. This could happen if the
       * card type either does not support currency conversion (e.g. Discover)
       * or if we always force the conversion type to be vendor (e.g. Amex). In
       * either case the user does not have the option to change the conversion
       * type so we don't need to set the data.
       */
      if (!conversionData) {
        $logger.info('currency_conversion_response_empty', { cardType });
        return;
      }

      const { api: apiActions, form: formActions } = appStore.getActions();
      const { type: conversionType } = conversionData;
      formActions.updateCurrencyConversionSelection(conversionType || 'PAYPAL');

      // If the user cannot change the conversion type then we do not
      // save the data in the store since the user cannot change options.
      if (!conversionData.canChangeConversionType) {
        $logger.info('currency_conversion_not_changeable', { cardType });
        return;
      }

      $logger.info('currency_conversion_changeable', { cardType });

      apiActions.setCurrencyConversionData(conversionData);

      return conversionData;
    })
    .catch(error => {
      // We ignore any errors that come back from this API and instead
      // rely on the planning response for currency conversion
      $logger.warn('currency_conversion_error', error);
    });
};

export { getCurrencyConversionData };
